import { render, staticRenderFns } from "./sport_competition_suggest_loser_revenge.vue?vue&type=template&id=46492ebd&scoped=true&"
import script from "./sport_competition_suggest_loser_revenge.vue?vue&type=script&lang=js&"
export * from "./sport_competition_suggest_loser_revenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46492ebd",
  null
  
)

export default component.exports